import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';
import PredesOriginImpcCodeNotRegisteredReport from '../../components/PredesOriginImpcCodeNotRegisteredReport';
import {
  getColumns,
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
} from '../redux/selectors/PredesOriginImpcCodeNotRegisteredSummarySelectors';

export function PredesOriginImpcCodeNotRegisteredSummaryContainer(props) {
  return (
    <PredesOriginImpcCodeNotRegisteredReport
      reportId={ReportDefinitions.PREDES_ORIGIN_IMPC_CODE_NOT_REGISTERED_SUMMARY.id}
      columns={props.columns}
      isLoading={props.isLoading}
      generatedOnDateTime={props.generatedDateTime}
      data={props.data}
    />
  );
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    generatedDateTime: getGeneratedOnDateTime(state),
    isLoading: getIsLoading(state),
    columns: getColumns(state),
  };
}

PredesOriginImpcCodeNotRegisteredSummaryContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.object),
};

export default connect(mapStateToProps)(PredesOriginImpcCodeNotRegisteredSummaryContainer);
